import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { MoovEventTypeEnum } from 'src/app/moov-common/services/challenge/moovStepState.enum';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent extends BaseComponent implements OnInit {

  @Input() value: any[] = [];
  @Input() presentFull : boolean = false;
  @Input() presentExpansionView : boolean = false;

  presentedValues: timelineObject[]=[];
  moovEventTypeEnumInstanace = MoovEventTypeEnum;
  
  constructor(public datepipe: DatePipe) {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();
    this.copyValues();
  }

  ngOnChanges(changes: SimpleChanges) : void {

    // if (changes.value.currentValue !== changes.value.previousValue && !changes.value.isFirstChange){
    //   console.log(`in timeline ngOnChanges`);
    //   this.copyValues();
    // }

    if (!changes.value.firstChange){
      if (!this.arrayEquals(changes.value.currentValue, changes.value.previousValue)){
        this.copyValues();
      }
    }
  }

  arrayEquals (a : any[], b: any[]) {
    return Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index]);
  }

  expandView(): void{
    this.presentFull = !this.presentFull;

    this.copyValues()
  }

  copyValues():void{
    if (this.presentFull){
      this.presentedValues = [...this.value];
    }
    else{
      // copy the last 3 elements
      this.presentedValues = this.value.slice(-2);
    }

    this.presentedValues.forEach((item, index) => {
      let currenttimeStamp = new Date(item.timeStamp);

      item.timeStamp = this.datepipe.transform(currenttimeStamp, this.getShortDateFormat())!;
    } );

    
  }

  getItemColortByType(itemType: MoovEventTypeEnum): string{
    if (itemType == MoovEventTypeEnum.LifetimeStart || itemType == MoovEventTypeEnum.LifetimeEnd){
      // start or end
      return '#4CAF50';
    }
    else if (itemType == MoovEventTypeEnum.Feedback){
      // user moov ended feedback
      return '#1792A5';
    }
    else if (itemType == MoovEventTypeEnum.LifetimeExtention || itemType == MoovEventTypeEnum.StepDone){
      // time extention
      return '#F44336';
    }
    else if (itemType == MoovEventTypeEnum.UserComment){
      // user comment
      return '#3D59E9';
    }
    return '#4CAF50';
  }

}

export interface timelineObject{
  type:number;
  score:number;
  timeStamp:string;
  content:string;
  additionalText: string;
  additionalNumericData: number;
}